import $ from "jquery";

// Identify if browser is IE 11 (or other non-modern browsers)
// More details: https://www.lullabot.com/articles/importing-css-breakpoints-into-javascript
export const ie = () => {
  return window.getComputedStyle(document.querySelector("body"), "::after")
      .getPropertyValue("content")
      .replace(/\"/g, "") === "ie";
};
